export default __webpack_public_path__ + "static/media/network-graph-1-rMIN.9fa39454.jpg";